/* eslint-disable no-underscore-dangle */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
/* eslint comma-dangle: ["off"] */

import React from 'react';
import {
  Layout,
  Typography,
} from 'antd';
import './PrivacyPolicy.less';
// import { Link } from 'react-router-dom';
// import Routes from '../../Global/Routes';

function PrivacyPolicy() {
  return (
    <Layout.Content className="privacyPage_bg">
      <div>
        <Typography.Title level={1} className="text-white text-center">Privacy Policy</Typography.Title>
        <div className="px-3 px-sm-5">
          <Typography.Title level={4} className="text-white text-left">1. Introduction</Typography.Title>
          <Typography.Paragraph className="off-white fs-16">
            Kuwait United Development (KUD) prioritizes user privacy and is dedicated to securely handling personal information collected through this website.
          </Typography.Paragraph>
          <Typography.Title level={4} className="text-white text-left">2. Data Collection</Typography.Title>
          <Typography.Paragraph className="off-white fs-16">
            We collect personal data, including names, contact details, resumes, and IP addresses, when users apply for jobs, request access to our portfolio, or subscribe to our newsletter. We also use cookies and similar tracking technologies for analytics and site functionality.
          </Typography.Paragraph>
          <Typography.Title level={4} className="text-white text-left">3. Use of Data</Typography.Title>
          <Typography.Paragraph className="off-white fs-16">
            Data is used for processing job applications, handling portfolio access requests, and providing newsletter updates. Tracking data may also be used for website analytics to enhance user experience.
          </Typography.Paragraph>
          <Typography.Title level={4} className="text-white text-left">4. Data Retention</Typography.Title>
          <Typography.Paragraph className="off-white fs-16">
            Personal data is retained only as long as necessary for its intended purpose. Job application data may be retained for recruitment purposes for a specified duration or until the role is filled, and newsletter subscriber data is retained until the user opts out.
          </Typography.Paragraph>
          <Typography.Title level={4} className="text-white text-left">5. Data Sharing</Typography.Title>
          <Typography.Paragraph className="off-white fs-16">
            Data is shared with third-party services strictly for analytical or operational purposes, with whom we have data protection agreements. KUD does not sell or disclose user data to unauthorized parties.
          </Typography.Paragraph>
          <Typography.Title level={4} className="text-white text-left">6. Security Measures</Typography.Title>
          <Typography.Paragraph className="off-white fs-16">
            We employ advanced security protocols, including encryption and regular audits, to protect personal information. Portfolio access approval is managed securely on the backend to ensure data integrity.
          </Typography.Paragraph>
          <Typography.Title level={4} className="text-white text-left">7. Data Breach Protocol</Typography.Title>
          <Typography.Paragraph className="off-white fs-16">
            In case of a data breach, KUD will promptly notify affected users and take immediate steps to secure the data and prevent further unauthorized access.
          </Typography.Paragraph>
          <Typography.Title level={4} className="text-white text-left">8. User Rights</Typography.Title>
          <Typography.Paragraph className="off-white fs-16">
            Users may request access to, correction of, or deletion of their data. They may also choose to disable cookies in their browser settings.
          </Typography.Paragraph>
          <Typography.Title level={4} className="text-white text-left">9. Policy Updates</Typography.Title>
          <Typography.Paragraph className="off-white fs-16">
            KUD may update this policy and will notify users of significant changes.
          </Typography.Paragraph>
        </div>
        {/* <Link to={Routes.home} className="d-table m-auto">
          <div className="border-0 border-radius primary r-bold h-40 bg-white d-flex justify-content-center align-items-center px-5">Home</div>
        </Link> */}
      </div>
    </Layout.Content>
  );
}

export default PrivacyPolicy;
